// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2LbWh","exploreItem":"styles_exploreItem__3tLTI","hotelName":"styles_hotelName__3RdOP","reviews":"styles_reviews__2O1Md","starAvg":"styles_starAvg__1n1_U"};